<template>
  <div>
    <form-side-bar
      :sb-id="formSBId"
      :sb-model="formSBModel"
      :resource="resource"
      :settings="settings"
      @add-todo-click="handleAddToDoClick"
      style="margin-bottom: 15px"
    />
    <slide-view
      :ref="slideRefId"
      :resource="resource"
      :settings="settings"
      :user-data="userData"
    />
    <contacts-side-bar
      :sb-id="contactsSBId"
      :sb-model="contactsSBModel"
      :resource="resource"
      @close-clicked="handleCloseContactsSideBar"
    />
    <resource-nav-bar
      v-if="resource"
      :resource="resource"
      @open-about="handleAboutClick"
    >
      <template v-slot:buttons-right>
        <b-button
          variant="outline-primary"
          size="md"
          class="my-2 my-md-0"
          @click="handleOpenContactsSideBar"
          style="margin-right: 15px"
        >
          <b-icon icon="telephone" aria-hidden="true" />
        </b-button>
      </template>
    </resource-nav-bar>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import ResourceNavBar from "@/components/blockResources/_components/resourceNavBar";
import FormSideBar from "./formSideBar";
import ContactsSideBar from "./contactsSideBar";
import SlideView from "./slideView";
export default {
  name: "Display_CallLog",
  mixins: [ResourceBlockDisplay],
  components: {
    ResourceNavBar,
    FormSideBar,
    ContactsSideBar,
    SlideView
  },
  props: {},
  created() {},
  mounted() {},
  computed: {
    /* SETTINGS */
    /* SETTINGS */
    /* DATA */
  },
  methods: {
    handleAddToDoClick(form) {
      console.log(`These form:${form}`);
      let tasks = {
        tasks: [form]
      };

      let notif = {
        title: `To Do Added`,
        description: "Your Task has been added",
        variant: "success"
      };

      const payload = {
        userData: tasks,
        notif: notif,
        key: "tasks"
      };

      this.handleUpdateUserData(payload);
    },
    /** CONTACTS **/
    handleOpenContactsSideBar() {
      this.contactsSBModel = true;
    },
    handleCloseContactsSideBar() {
      this.contactsSBModel = false;
    },
    handleGoBack() {
      this.$refs[this.slideRefId].handleGoBack();
    }
  },
  data() {
    return {
      slideRefId: "slide-view",
      assetsURLHome: "/assets/apps/todone/",
      audioDuration: null,
      formSBId: "form-sidebar",
      formSBModel: false,
      contactsSBId: "contacts-sidebar",
      contactsSBModel: false,
      addContactSBModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
